import React from 'react';
import { Link } from 'react-router-dom';

const Refundpolicy = () => {
  return (
    <>
      {/* Custom Cursors */}
      <div className="custom-cursor-one"></div>
      <div className="custom-cursor-two"></div>

      {/* inner-page hero start */}
      <div
        className="inner-page-hero"
        style={{ backgroundImage: 'url(/assets/images/background/bg3.png)' }}
      >
        <div className="container">
          <div className="hero-heading-title">
            <h2>Refund Policy</h2>
          </div>
          <ul className="bradcrumb">
            <li><a href="/">Home</a></li>
            <li><Link to="#">Refund Policy</Link></li>
          </ul>
        </div>
      </div>
      {/* inner-page hero end */}

      <section className="privacy-section">
        <div className="container">
          <div className="row justify-content-center">

            <div className="col-lg-12">
              <div className="privacy-content-card">

                {/* Header */}
                <div className="mb-5 text-center">
                  <span className="heading-subtitle wow fadeInUp animated">💰 Refund Policy</span>
                  <h2 className="wow fadeInUp animated">
                    Wall Street Finz — Refund & Cancellation Policy
                  </h2>

                  <div className="meta-info-box">
                    <p><strong>Effective Date:</strong> Immediately upon publication</p>
                    <p><strong>Owned & Operated By:</strong> Wall Street Merchants Pvt Ltd.</p>
                  </div>

                  <p className="intro-text mt-4">
                    This Refund & Cancellation Policy outlines the terms under which refunds are
                    processed and loan applications may be cancelled at <strong>Wall Street Finz</strong>.
                    Our policies are designed to be transparent, fair, and compliant with regulatory guidelines.
                  </p>
                </div>

                <hr className="divider" />

                {/* 1 Loan Application Cancellation */}
                <div className="policy-block">
                  <h3>1. Loan Application Cancellation</h3>
                  <p>You may cancel your loan application under the following conditions:</p>

                  <div className="info-grid">

                    <div className="info-card">
                      <div className="icon-box"><i className="flaticon-clock"></i></div>
                      <h4>A. Before Loan Approval</h4>
                      <ul>
                        <li>Within 24 hours of application: No fees</li>
                        <li>After 24 hours but before approval: ₹500 processing fee may apply</li>
                        <li>Processing fee refundable only if KYC not initiated</li>
                      </ul>
                    </div>

                    <div className="info-card">
                      <div className="icon-box"><i className="flaticon-approval"></i></div>
                      <h4>B. After Loan Approval</h4>
                      <ul>
                        <li>Before disbursement: As per sanction letter terms</li>
                        <li>After disbursement: Prepayment terms apply</li>
                        <li>Processing fees non-refundable after approval</li>
                      </ul>
                    </div>

                    <div className="info-card">
                      <div className="icon-box"><i className="flaticon-cancel"></i></div>
                      <h4>C. Non-Refundable Charges</h4>
                      <ul>
                        <li>GST on processing fees</li>
                        <li>Interest for active loan period</li>
                        <li>Government taxes & statutory charges</li>
                        <li>Value-added service charges</li>
                      </ul>
                    </div>

                  </div>
                </div>

                {/* 2 Refund Eligibility */}
                <div className="policy-block">
                  <h3>2. Refund Eligibility</h3>
                  <p>Refunds are applicable in the following situations:</p>
                  <ul className="check-list">
                    <li>Excess payment made towards loan repayment</li>
                    <li>Processing fees paid for cancelled applications (as per cancellation terms)</li>
                    <li>Security deposit after loan closure (if applicable)</li>
                    <li>Technical errors causing duplicate payments</li>
                  </ul>
                </div>

                {/* 3 Refund Timeline */}
                <div className="policy-block">
                  <h3>3. Refund Process Timeline</h3>

                  <div className="info-grid">

                    <div className="info-card">
                      <h4>Refund Request Submission</h4>
                      <p>Submit request via email with transaction details.</p>
                      <p className="small text-muted">Within 7 days of payment</p>
                    </div>

                    <div className="info-card">
                      <h4>Verification & Approval</h4>
                      <p>Our team verifies eligibility and approves request.</p>
                      <p className="small text-muted">3-5 working days</p>
                    </div>

                    <div className="info-card">
                      <h4>Refund Processing</h4>
                      <p>Refund initiated to original payment source.</p>
                      <p className="small text-muted">7-10 working days</p>
                    </div>

                    <div className="info-card">
                      <h4>Funds Receipt</h4>
                      <p>Amount reflects in your account.</p>
                      <p className="small text-muted">3-5 banking days</p>
                    </div>

                  </div>
                </div>

                {/* 4 How to Request */}
                <div className="policy-block">
                  <h3>4. How to Request Refund / Cancellation</h3>

                  <h4>Email Request</h4>
                  <p>
                    Send email to <a href="mailto:info@wallstreetfinz.com">info@wallstreetfinz.com</a> with:
                  </p>

                  <ul className="dot-list">
                    <li>Application / Loan reference number</li>
                    <li>Reason for cancellation or refund</li>
                    <li>Transaction ID & proof of payment</li>
                    <li>Registered mobile number</li>
                  </ul>

                  <h4 className="mt-4">Customer Support</h4>
                  <p>
                    Call our support team at <strong>+91-9911998997</strong><br />
                    Available: Monday to Saturday, 9:30 AM – 6:30 PM
                  </p>
                </div>

                {/* 5 Important Notes */}
                <div className="policy-block">
                  <h3>5. Important Notes</h3>

                  <div className="alert-box warning">
                    Policy Compliance: This policy is subject to the terms and conditions of your loan agreement.
                    In case of discrepancy, the loan agreement terms shall prevail.
                  </div>

                  <ul className="check-list mt-3">
                    <li>Refund requests processed only on working days</li>
                    <li>Refunds credited to original payment source only</li>
                    <li>Keep all transaction records until refund completion</li>
                    <li>Compliant with RBI Fair Practices Code</li>
                  </ul>
                </div>

                {/* Contact */}
                <div className="contact-block">
                  <h3>Contact Us</h3>
                  <p>For questions or refund related requests:</p>

                  <div className="contact-details">
                    <div className="contact-row">
                      <i className="flaticon-email"></i>
                      <a href="mailto:info@wallstreetfinz.com">info@wallstreetfinz.com</a>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>

    </>
  );
};

export default Refundpolicy;